module.exports = __webpack_public_path__ + "assets/note.4515cfad.svg";